import type { Phase } from "@/api/objekte";
import { cn } from "@/lib/utils";

const STYLES: Record<Phase, string> = {
  prospect: "bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-300",
  "in-analyse":
    "bg-purple-100 text-purple-800 dark:bg-purple-950 dark:text-purple-300",
  besichtigt:
    "bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-300",
  "angebot-raus":
    "bg-orange-100 text-orange-900 dark:bg-orange-950 dark:text-orange-300",
  gekauft: "bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-300",
  abgelehnt: "bg-zinc-100 text-zinc-700 dark:bg-zinc-900 dark:text-zinc-400",
  out: "bg-zinc-100 text-zinc-500 dark:bg-zinc-900 dark:text-zinc-500",
};

const LABELS: Record<Phase, string> = {
  prospect: "Prospect",
  "in-analyse": "In Analyse",
  besichtigt: "Besichtigt",
  "angebot-raus": "Angebot raus",
  gekauft: "Gekauft",
  abgelehnt: "Abgelehnt",
  out: "Out",
};

export function PhaseBadge({ phase }: { phase: Phase }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
        STYLES[phase],
      )}
    >
      {LABELS[phase]}
    </span>
  );
}

export const PHASE_OPTIONS: { value: Phase; label: string }[] = (
  Object.keys(LABELS) as Phase[]
).map((value) => ({ value, label: LABELS[value] }));
